<template>
  <div>
    <router-view></router-view>
    <!--to-do colocar só pro mobile-->
    <!--<div v-if="supportWhatsapp && currentRouteName != 'FAQ' && currentRouteName != 'Docs' &&  currentRouteName != 'Landing' && currentRouteName != 'PagamentosSingle' && currentRouteName != 'Editor'" id="mybutton" v-bind:class="{'desktop-whatsapp': (!isMobile), 'mobile-whatsapp': isMobile}">
      <a class="btn button" style="background-color : #128C7E;
      color: white;
      padding: 10px 20px;
      border-radius: 80px;
      border-color: #128C7E;"
      @click="handleWhatsappClick"
      target="_blank"
      ><i class="fa fa-whatsapp"></i>
      </a>
    </div>-->
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";

export default {
  name: 'app',
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    youtubeTutorial() {
      return localStorage.youtubeTutorial;
    },
    supportEmail() {
      return localStorage.supportEmail;
    },
    supportWhatsapp() {
      return localStorage.supportWhatsapp;
    },
    currentRouteName() {
      return this.$route.name;
    },
    isMobile() {
      return isMobile;
    }
  },
  methods: {
    handleWhatsappClick() {
      //if (this.$route.name != "Landing" && window.location.href.indexOf("pages") < 0) {
        //this.$router.push({ name: 'FAQ'});
      //} else {
        window.location.href = "https://api.whatsapp.com/send?phone=558199719158&text=Tenho%20uma%20d%C3%BAvida%20sobre%20o%20Sleeker%2C%20pode%20me%20ajudar%3F"
      //}
    }, 
    makeid(length) {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
  },
  created: async function() { 
    if (!localStorage.userIdentifier) {
      localStorage.userIdentifier = this.makeid(20);
    }
  }
}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>

<style>
  @font-face {
    font-family: 'Poppins ExtraBold';
    src: url(https://postrapido.s3.us-east-2.amazonaws.com/fonts/Poppins-ExtraBold.ttf);
  }
  @font-face {
    font-family: 'Buffalo';
    src: url(https://postrapido.s3.us-east-2.amazonaws.com/fonts/BuffaloScript-Regular.otf);
  }
    
</style>

<style>
  @media screen and (max-width: 1200px) {
    .desktop {
      visibility: hidden;
      clear: both;
      float: left;
      margin: 10px auto 5px 20px;
      width: 28%;
      display: none;
    }
  }

  .mobile    { display:block; }

  @media screen and (min-width: 1200px) {
    .mobile {
      display: none;
    }
  }

  .mobile-whatsapp {
    position: fixed;
    bottom: 100px;
    left: 20px;
    border: 1ch;
  }

  .desktop-whatsapp {
    position: fixed;
    bottom: 20px;
    right: 20px;
    border: 2ch;
  }
</style>
